var map = {
	"./amplify-amazon-button_5.entry.js": [
		57130,
		699,
		130
	],
	"./amplify-auth-container.entry.js": [
		96808,
		808
	],
	"./amplify-auth-fields_9.entry.js": [
		61031,
		31
	],
	"./amplify-authenticator.entry.js": [
		36285,
		699,
		285
	],
	"./amplify-button_3.entry.js": [
		26949,
		949
	],
	"./amplify-chatbot.entry.js": [
		16208,
		208
	],
	"./amplify-checkbox.entry.js": [
		5675,
		675
	],
	"./amplify-confirm-sign-in_7.entry.js": [
		46124,
		699,
		124
	],
	"./amplify-container.entry.js": [
		76380,
		380
	],
	"./amplify-federated-buttons_2.entry.js": [
		83063,
		699,
		63
	],
	"./amplify-federated-sign-in.entry.js": [
		81308,
		308
	],
	"./amplify-form-field_4.entry.js": [
		49848,
		699,
		848
	],
	"./amplify-greetings.entry.js": [
		32753,
		699,
		753
	],
	"./amplify-icon-button.entry.js": [
		71280,
		435
	],
	"./amplify-icon.entry.js": [
		51078,
		78
	],
	"./amplify-link.entry.js": [
		11550,
		550
	],
	"./amplify-nav_2.entry.js": [
		37361,
		699,
		361
	],
	"./amplify-photo-picker.entry.js": [
		52217,
		217
	],
	"./amplify-picker.entry.js": [
		75188,
		188
	],
	"./amplify-radio-button_3.entry.js": [
		53973,
		699,
		973
	],
	"./amplify-s3-album.entry.js": [
		60778,
		24,
		778
	],
	"./amplify-s3-image-picker.entry.js": [
		90602,
		24,
		602
	],
	"./amplify-s3-image.entry.js": [
		3286,
		24,
		286
	],
	"./amplify-s3-text-picker.entry.js": [
		97288,
		24,
		288
	],
	"./amplify-s3-text.entry.js": [
		23722,
		24,
		722
	],
	"./amplify-select-mfa-type.entry.js": [
		21724,
		724
	],
	"./amplify-sign-in-button.entry.js": [
		60280,
		280
	],
	"./amplify-tooltip.entry.js": [
		40289,
		289
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 21766;
module.exports = webpackAsyncContext;